var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasId)?_c('a',{attrs:{"id":_vm.slugifiedId,"aria-label":"Section anchor link","aria-hidden":"true"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }